import { useEffect, useRef } from 'react'
import { Subject, combineLatest } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import useBaseState from 'hooks/useBaseState'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { requestSectionPrecedents } from 'services/PrecedentsService'
import { observeSelected } from 'front-end-core/services/StateService'
import { observePageState } from 'front-end-core/services/PageStateService'
import { mapResponse } from 'front-end-core/helpers/dataflow'

const usePrecedentSectionDetails = (props) => {
  const State = useRef(new Subject())
  const Until = useRef(new Subject())

  const { baseState } = useBaseState(State.current, { response: RESPONSE_PENDING, expandedSection: null })

  const evaluateExpandedSectionId = ({ props: { expandedSection }, precedents: { files, parents }, pageState }) => {
    if (Object.prototype.hasOwnProperty.call(pageState, 'expandedSection')) {
      return pageState
    }
    if (expandedSection && Object.prototype.hasOwnProperty.call(files, expandedSection)) {
      return { expandedSection: files[expandedSection].parentId }
    }
    if (expandedSection && Object.prototype.hasOwnProperty.call(parents, expandedSection)) {
      return { expandedSection }
    }
    return {}
  }

  const getSource = ({ view, sectionId }) => {
    const { aol } = props
    const combineRequests = function (precedents, selectedIds, pageState) {
      return ({
        response: { ...precedents, selectedIds, ...pageState },
        ...evaluateExpandedSectionId({ props, precedents, selectedIds, pageState })
      })
    }
    const culpritMap = (culprit) => ({ response: culprit })
    return combineLatest(
      [requestSectionPrecedents(view === 'browse' ? 'precedents' : view, sectionId, aol),
        observeSelected('precedents'),
        observePageState()],
      mapResponse(combineRequests, culpritMap)
    )
  }

  const connectSource = (props) => {
    getSource(props).pipe(
      takeUntil(Until.current)
    ).subscribe(s => State.current.next(s))
  }

  useEffect(() => {
    Until.current.next(true)
    connectSource(props)
  }, [props])

  return { baseState }
}

export default usePrecedentSectionDetails
